import Foundation from 'foundation-sites';
// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination, Autoplay, EffectFade, Controller } from 'swiper/core';
import $ from "jquery";
// window.$ = $;
// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Controller]);

$(document).foundation();

$(document).ready(function($) {
  var artistSwiper = new Swiper(".artistsSwiper", {
    effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 1000,
      disableOnInteraction: false
    },
    speed: 3000,
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  });

  var slider = new Swiper(".block-slider .swiper-container", {
    speed: 500,
    spaceBetween: 30,
    autoHeight: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  });

  var blockRoomsSliderContent = new Swiper(".block-rooms-slider__content", {
    init: false,
    speed: 500,
    spaceBetween: 30,
    autoHeight: false,
    allowTouchMove: false,
  });

  var blockRoomsSlider = new Swiper(".block-rooms-slider__cards", {
    speed: 500,
    spaceBetween: 30,
    autoHeight: false,
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    controller: {
      control: blockRoomsSliderContent,
    }
  });

  blockRoomsSliderContent.controller.control = blockRoomsSlider;
  blockRoomsSliderContent.init();
});
